import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function FileUpload({ name, accept, onChange, label }) {
    const [fileName, setFileName] = useState('');
    const { t } = useTranslation();

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
        } else {
            setFileName('');
        }
        if (onChange) onChange(e);
    };

    return (
        <div className="file-upload-wrapper">
            <input
                type="file"
                name={name}
                accept={accept}
                onChange={handleChange}
            />
            <div className="file-upload-display">
                <div className="file-upload-icon">📄</div>
                <div className="file-upload-text">
                    <strong>
                        {fileName || label || t('common.choose_file')}
                    </strong>
                    <small>
                        {fileName ? t('common.file_selected_change') : t('resume.click_browse')}
                    </small>
                </div>
                <div className="file-upload-btn">{t('resume.browse')}</div>
            </div>
        </div>
    );
}

export default FileUpload;